module.exports = __webpack_public_path__ + "img/page-1_img07.1757f264.jpg";